export enum actionTypes {
    SET_SESSION_DURATION = 'SESSION:DURATION:SET',
    SET_SESSION_ENABLED = 'SESSION:ENABLED:SET',
    SET_SESSION_LIMIT = 'SESSION:LIMIT:SET',
    SET_SESSION_TIMEOUT_SHOWN = 'SESSION:TIMEOUT_SHOWN:SET'
}
